var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"left-top",attrs:{"title":"物联网故障类型"}},[_c('pieCharts',{attrs:{"id":"lotgzlx","lists":_vm.datas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }